import React, { useState, useEffect } from 'react'
import { useTrans } from 'hooks'
import { useOrdiniQuery } from 'gql/graphql'
import dayjs from 'dayjs'
import { stati } from 'utils/stati'
import { Mail } from 'components/atoms/Icons'
import { MyAccountOrdiniBlock, Ordine } from 'components/molecules'
import { MyAccountPage } from 'components/organisms'

const customParseFormat = require('dayjs/plugin/customParseFormat')

dayjs.extend(customParseFormat)

interface Props {
  pagina?: any
}

const MyAccountOrdiniTemplate = (props: Props) => {
  const { pagina = null } = props

  const t = useTrans()
  const { data: dataOrdini } = useOrdiniQuery()
  const [ordini, setOrdini] = useState([])
  const [ordiniInCorso, setOrdiniInCorso] = useState([])
  const [ordiniPassati, setOrdiniPassati] = useState({})

  useEffect(() => {
    if (dataOrdini?.ordini) {
      setOrdini(dataOrdini.ordini.edges.map(({ node }) => ({
        id: node.pk,
        stato: { 
          nome: node.stato.alias,
          chiave: node.stato.chiave,
         },
        spedizioneLink: node.spedizioneOrdine?.tracking ? `http://www.tnt.it/tracking/Tracking.do?consigNos=${node.spedizioneOrdine?.tracking}&wt=1` : null,
        codice: node.codice,
        totale: node.prezzoTotaleScontato,
        dataOrdine: node.data,
        estero: node.estero,
        dataOrdineMese: dayjs(node.data, "DD/MM/YYYY").locale('it').format('YYYY-MM'),
        righeProdotti: node.righeOrdine.filter(riga => riga.tipologia?.toLowerCase() === "prodotto").map( riga => ({ 
          id: riga.pk,
          quantita: riga.quantitaOrdinata,
          prodotto: {
            id: riga.prodotto?.pk,
            imageUrl: riga.prodotto?.prodotto?.mainImage,
            nome: riga.prodotto?.prodotto?.nomeFantasia,
          }
        })),
        }))
      )
    }
  }, [dataOrdini])

  useEffect(() => {
    if (ordini.length > 0) {
      // const ordiniReversed = ordini.reverse()
      setOrdiniInCorso(
        ordini.filter((ordine) =>
          stati
            .filter((stato) => stato.chiave !== 'consegnato')
            .some(({ chiave }) => chiave === ordine.stato.chiave)
        )
      )
      const ordiniPassatiAll = ordini.filter(
        (ordine) =>
          !stati
            .filter((stato) => stato.chiave !== 'consegnato')
            .some(({ chiave }) => chiave === ordine.stato.chiave)
      )

      let ordiniPassatiTemp = {}
      ordiniPassatiAll.forEach((ordine) => {
        if (!ordiniPassatiTemp[ordine.dataOrdineMese]) ordiniPassatiTemp[ordine.dataOrdineMese] = []
        ordiniPassatiTemp[ordine.dataOrdineMese].push(ordine)
      })

      setOrdiniPassati(ordiniPassatiTemp)
    }
  }, [ordini])

  return (
    <MyAccountPage pagina={{ titolo: pagina?.titolo, descrizione: pagina?.descrizione, icon: <Mail /> }} activeMenuKey="ordini">
      {ordiniInCorso.length > 0 && (
        <MyAccountOrdiniBlock>
          {ordiniInCorso.map((ordine) => (
            <Ordine ordine={ordine} key={`myaccount-ordini-template__ordine__${ordine.id}`} />
          ))}
        </MyAccountOrdiniBlock>
      )}
      {Object.keys(ordiniPassati).map((data) => (
        <MyAccountOrdiniBlock data={data} key={`myaccount-ordini-template__data-ordine__${data}`}>
          {ordiniPassati[data].map((ordine) => (
            <Ordine ordine={ordine} key={`myaccount-ordini-template__ordine__${ordine.id}`} />
          ))}
        </MyAccountOrdiniBlock>
      ))}
    </MyAccountPage>
  )
}

export default MyAccountOrdiniTemplate
